/**
 * Предзагрузка КОДА ленивой страницы по адресу (agroai-0e8.26, ADR-0020).
 *
 * Кабинеты (`/my/*`, `/ops/*`), вода и карантин — отдельные куски сборки:
 * первый переход на них ждал сначала кусок кода, затем данные. Таблица
 * маршрутов (`App.tsx`) регистрирует здесь загрузчик каждой ленивой страницы,
 * а меню зовёт {@link preloadRoute} по намерению — тем же жестом, что грузит
 * данные раздела (`api/prefetch.ts`). Модуль без зависимостей: меню не
 * импортирует таблицу маршрутов (она импортирует меню через оболочку).
 */

const loaders = new Map<string, () => Promise<unknown>>();

/** Зарегистрировать загрузчик кода страницы по адресу маршрута. */
export function registerRoutePreload(path: string, load: () => Promise<unknown>): void {
  loaders.set(path, load);
}

/** Начать загрузку кода страницы, если она ленивая. Повтор бесплатен. */
export function preloadRoute(pathname: string): void {
  const load = loaders.get(pathname);
  if (load) void load().catch(() => undefined);
}
